@import '~less/global-variables';
@import '~less/layout/helpers';

/**
 * Threads list (inbox)
 */

.threadlist {
  max-width: @screen-xs-max;
  margin: 0 auto 30px auto;
}

.inbox-controls {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin-bottom: 20px;
}

.inbox-view-filters {
  display: flex;
  flex: 0 0 auto;
  gap: 0;
  border: 1px solid darken(@brand-primary, 15%);
  border-radius: @border-radius-base;
  background: #fff;

  .btn {
    border: 0;
    border-radius: 0;
    white-space: nowrap;
    background: transparent;
    &:first-child {
      border-radius: (@border-radius-base - 1) 0 0 (@border-radius-base - 1);
    }
    &:last-child {
      border-radius: 0 (@border-radius-base - 1) (@border-radius-base - 1) 0;
    }
  }

  .btn[aria-current='page'] {
    background: darken(@brand-primary, 15%);
    color: #fff;
    font-weight: 600;
  }
}

.inbox-search {
  flex: 1 1 320px;
  max-width: 420px;
  margin-left: auto;
}

.inbox-search-status {
  margin: 6px 0 0;
}

@media (max-width: @screen-xs-max) {
  .inbox-controls {
    display: block;
  }

  .inbox-view-filters {
    display: flex;
    margin-bottom: 10px;

    .btn {
      flex: 1 1 50%;
      white-space: normal;
    }
  }

  .inbox-search {
    max-width: none;
  }
}

.threadlist-thread {
  &.threadlist-thread-unread {
    font-weight: bold;
    time {
      color: @brand-primary;
    }
  }

  a,
  a:hover,
  a:active {
    text-decoration: none;
    color: @text-color;
  }

  &,
  * {
    .cursor-pointer();
  }
}

.threadlist-thread-excerpt {
  display: inline-block;
  max-width: 350px;
  // https://developer.mozilla.org/en-US/docs/Web/CSS/word-wrap
  word-wrap: break-word;
  // http://getbootstrap.com/css/#less-mixins-truncating
  .text-overflow();

  @media (max-width: @screen-xs-max) {
    max-width: 200px;
  }
}
